// Mock data for energy smart meters
export const mockSmartMeters = [
  {
    deviceId: "ENG001",
    location: "Building A, Floor 1",
    status: "Healthy",
    batteryLevel: 87,
    signalStrength: 92,
    lastCommunication: "2024-12-15T14:30:00Z",
    firmwareVersion: "v3.5.2",
    readings: {
      voltage: 120.5,
      current: 15.2,
      frequency: 60.01,
      power: 1832.4,
      totalEnergy: 45678.9
    },
    maintenanceStatus: {
      lastMaintenance: "2024-09-10",
      nextScheduled: "2026-01-10", 
      alerts: []
    }
  },
  {
    deviceId: "ENG002",
    location: "Building A, Floor 2",
    status: "Warning",
    batteryLevel: 42,
    signalStrength: 78,
    lastCommunication: "2024-12-15T13:45:00Z",
    firmwareVersion: "v3.5.1",
    readings: {
      voltage: 119.8,
      current: 18.7,
      frequency: 59.97,
      power: 2240.3,
      totalEnergy: 38921.5
    },
    maintenanceStatus: {
      lastMaintenance: "2024-08-15",
      nextScheduled: "2026-02-15", 
      alerts: ["Battery replacement needed"]
    }
  },
  {
    deviceId: "ENG003",
    location: "Building B, Floor 1",
    status: "Critical",
    batteryLevel: 12,
    signalStrength: 31,
    lastCommunication: "2024-12-14T09:15:00Z",
    firmwareVersion: "v3.4.9",
    readings: {
      voltage: 118.3,
      current: 9.8,
      frequency: 60.05,
      power: 1159.3,
      totalEnergy: 29384.7
    },
    maintenanceStatus: {
      lastMaintenance: "2024-07-20",
      nextScheduled: "2026-01-20", 
      alerts: ["Communication failure", "Battery critical", "Maintenance overdue"]
    }
  },
  {
    deviceId: "ENG004",
    location: "Building B, Floor 2",
    status: "Healthy",
    batteryLevel: 95,
    signalStrength: 89,
    lastCommunication: "2024-12-15T14:25:00Z",
    firmwareVersion: "v3.5.2",
    readings: {
      voltage: 121.2,
      current: 12.4,
      frequency: 60.00,
      power: 1502.9,
      totalEnergy: 32456.8
    },
    maintenanceStatus: {
      lastMaintenance: "2024-10-05",
      nextScheduled: "2026-02-05", 
      alerts: []
    }
  },
  {
    deviceId: "ENG005",
    location: "Building C, Floor 1",
    status: "Warning",
    batteryLevel: 56,
    signalStrength: 68,
    lastCommunication: "2024-12-15T11:05:00Z",
    firmwareVersion: "v3.5.0",
    readings: {
      voltage: 120.1,
      current: 14.9,
      frequency: 59.98,
      power: 1787.5,
      totalEnergy: 41232.6
    },
    maintenanceStatus: {
      lastMaintenance: "2024-08-25",
      nextScheduled: "2026-02-25", 
      alerts: ["Firmware update required"]
    }
  },
  {
    deviceId: "sm-10023",
    location: "Building D, Floor 1",
    status: "Healthy",
    batteryLevel: 90,
    signalStrength: 95,
    lastCommunication: "2024-12-15T16:30:00Z",
    firmwareVersion: "v3.5.3",
    readings: {
      voltage: 120.8,
      current: 14.5,
      frequency: 60.00,
      power: 1750.5,
      totalEnergy: 38975.6
    },
    maintenanceStatus: {
      lastMaintenance: "2024-10-15",
      nextScheduled: "2026-02-15", 
      alerts: []
    }
  },
  {
    deviceId: "sm-10045",
    location: "Building E, Floor 2",
    status: "Warning",
    batteryLevel: 40,
    signalStrength: 65,
    lastCommunication: "2024-12-15T12:45:00Z",
    firmwareVersion: "v3.5.0",
    readings: {
      voltage: 119.5,
      current: 17.8,
      frequency: 59.95,
      power: 2130.1,
      totalEnergy: 42367.9
    },
    maintenanceStatus: {
      lastMaintenance: "2024-08-05",
      nextScheduled: "2026-01-05", 
      alerts: ["Unusual power fluctuation pattern"]
    }
  }
];
